export default "__VITE_ASSET__CqvSY$jM__"